export default __webpack_public_path__ + "static/media/host_absent.fd2d3388.svg";